<template>
  <component
    :is="component"
    :to="linkUrl || ''"
    class="flex flex-col items-center justify-center h-32 px-4 bg-white rounded shadow-md cursor-default"
    :class="{ 'cursor-pointer': linkUrl }"
  >
    <CImage
      v-if="(content as ContentfulAssortmentIcon).fields?.icon || (content as Assortment).icon"
      :src="iconSrc"
      :alt="title"
      height="64"
      width="64"
    />
    <span class="mt-2 text-xs font-bold text-center text-primary-900">{{ title }}</span>
  </component>
</template>

<script setup lang="ts">
import type { Assortment } from '@/types/contentful';

type ContentfulAssortmentIcon = {
  fields: {
    icon: {
      fields: {
        file: {
          url: string;
        };
      };
    };
    title: string;
    linkUrl: string;
  };
};

type Props = {
  content: ContentfulAssortmentIcon | Assortment;
};

const props = defineProps<Props>();

const iconSrc = computed(() => {
  return (
    (props.content as ContentfulAssortmentIcon)?.fields?.icon?.fields?.file?.url ||
    (props.content as Assortment)?.icon.url
  );
});

const title = computed(() => {
  return (props.content as ContentfulAssortmentIcon)?.fields?.title || (props.content as Assortment)?.title;
});

const linkUrl = computed(() => {
  return (props.content as ContentfulAssortmentIcon)?.fields?.linkUrl || (props.content as Assortment)?.linkUrl;
});

const component = linkUrl.value ? resolveComponent('NuxtLink') : 'div';
</script>

<script lang="ts">
export default defineComponent({
  name: 'AssortmentIcon',
});
</script>
